import { BaseModalState } from "@/entities/modals/types";

export function createModalStateSetter<T extends BaseModalState>(
  setModalState: React.Dispatch<React.SetStateAction<T>>
): React.Dispatch<React.SetStateAction<boolean>> {
  return (value) => {
    setModalState((prevState) => ({
      ...prevState,
      isOpen: typeof value === "function" ? value(prevState.isOpen) : value
    }));
  };
}

export function createUnsavedChangesModalSetter(
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
  handleCloseAttempt: (onConfirm: () => void) => void
): React.Dispatch<React.SetStateAction<boolean>> {
  return (value) => {
    const newValue = typeof value === "function" ? value(true) : value;

    if (!newValue) {
      // Trying to close the modal - check for unsaved changes
      handleCloseAttempt(() => setIsOpen(false));
    } else {
      // Opening the modal
      setIsOpen(newValue);
    }
  };
}
